"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
const selectors_1 = require("../../exports/store/selectors");
const i18n_1 = require("../../exports/i18n");
/**
 * here's `views` means table view / gallery view, not `view` in table area.
 */
class View {
    static getSrcView(snapshot, activeViewId) {
        const views = snapshot.meta.views;
        let srcView;
        if (activeViewId) {
            srcView = (0, selectors_1.getViewById)(snapshot, activeViewId);
        }
        if (!srcView) {
            srcView = views[0];
        }
        return srcView;
    }
    static defaultRows(srcView) {
        if (srcView) {
            return srcView.rows;
        }
        return [];
    }
    /**
     *  `record` has different name in different view, such as `row`, `record`, `task`, etc.
     * every view need to define their own name of record.
     */
    get recordShowName() {
        return (0, i18n_1.t)(i18n_1.Strings.record);
    }
    get recordShowUnit() {
        // TODO: i18n
        return '条';
    }
}
exports.View = View;
//# sourceMappingURL=views.js.map